/**
 * =====================================================
 * Piva subscription.js
 * =====================================================
 *
 * Progetto: Ventura Shop
 * Tipo: Satellite JS
 * Dipendenza: main.js (namespace globale "ventura")
 *
 * Descrizione:
 * Questo file contiene tutte le logiche JS specifiche
 * per la pagina form subscription. Si integra con il namespace
 * globale "ventura" definito in main.js.
 *
 * Note:
 * - Non dipendere da altri satelliti, solo da main.js
 * - Il caricamento condizionale avviene tramite la
 *   variabile globale `isTemplate` passata da PHP
 *   tramite WP_PARAMS.is_page_template.
 * - Tutte le funzioni dovrebbero essere incapsulate
 *   all'interno di ventura o di closure locali.
 *
 * Esempio di utilizzo:
 *   ventura.checkoutInit();
 *
 * =====================================================
 */
const ventura = window.ventura;
window.isTemplate = window.WP_PARAMS ? window.WP_PARAMS.is_page_template : null;

(function($) {
    if (window.isTemplate !== 'templ-landing-piva.php') return; // si avvia solo sul template del form partita iva

    /**
     * Gestisce i contatori dei campi
     */
    ventura.formPivaCounter = {
        config: [
            { 'f-nome': 50 },
            { 'f-cognome': 50 },
            { 'f-piva': 11 }
        ],

        init: function($context = $(document)) {
            const self = this;
            
            $.each(this.config, function() {
                $.each(this, function(inputId, maxLength) {
                    const $input = $('#' + inputId);
                    const $hint = $('#' + inputId.replace('f-', 'hint-'));
                    
                    if ($input.length === 0 || $hint.length === 0) return;

                    // Reset e Setup attributi
                    $input.removeAttr('maxlength')
                          .attr('maxlength', maxLength)
                          .attr('data-length', true);

                    self._renderCounter($input, $hint, maxLength);

                    // Listener evento
                    $input.off('keyup').on('keyup', function() {
                        self._renderCounter($(this), $hint, maxLength);
                    });
                });
            });
        },

        _renderCounter: function($input, $hint, maxLength) {
            const remaining = maxLength - $input.val().length;
            
            if (remaining < 0) {
                $hint.addClass('input-counter-error').text('testo troppo lungo');
                $input.closest('.form-row').addClass('woocommerce-invalid-character-length');
            } else {
                $hint.removeClass('input-counter-error').text(remaining + ' caratteri rimanenti');
                $input.closest('.form-row').removeClass('woocommerce-invalid-character-length');
            }
        }
    };

    /**
     * Validazione Partita IVA
     */
    ventura.formPivaValidation = {
        validatePIVA: function(piva) {
            piva = piva.trim();
            if (!/^\d{11}$/.test(piva)) return false;
            
            let s = 0;
            for (let i = 0; i < 10; i++) {
                let n = parseInt(piva[i]);
                if (i % 2 !== 0) {
                    n *= 2;
                    if (n > 9) n -= 9;
                }
                s += n;
            }
            return (10 - (s % 10)) % 10 === parseInt(piva[10]);
        },

        init: function() {
            const self = this;
            
            // Validazione in tempo reale della Partita IVA
            $('#f-piva').on('input', function() {
                const $this = $(this);
                const value = $this.val().trim();
                
                if (value.length === 11) {
                    const isValid = self.validatePIVA(value);
                    if (!isValid) {
                        $this.closest('.form-row').addClass('woocommerce-invalid');
                        $('#hint-piva').text('Partita IVA non valida').css('color', 'red');
                    } else {
                        $this.closest('.form-row').removeClass('woocommerce-invalid');
                        $('#hint-piva').text('Partita IVA valida').css('color', 'green');
                    }
                } else {
                    $this.closest('.form-row').removeClass('woocommerce-invalid');
                    $('#hint-piva').css('color', '');
                }
            });
        }
    };

    /**
     * Gestione messaggi
     */
    ventura.formPivaMessages = {
        show: function(type, text) {
            const $el = $('#form-msg');
            $el.removeClass('error success').addClass('form-msg ' + type);
            $el.text(text);
        },
        clear: function() {
            $('#form-msg').removeClass('error success').addClass('form-msg');
            $('#form-msg').text('');
        }
    };

    /**
     * Funzione principale del form
     */
    ventura.formPivaSubscription = function() {
        // Inizializza contatori
        ventura.formPivaCounter.init();
        
        // Inizializza validazione PIVA
        ventura.formPivaValidation.init();

        // Validazione campi prima dell'invio (SOLO CONTROLLI)
        $('#btn-submit').on('click', function(e) {
            e.preventDefault();
            
            const $nome = $('#f-nome');
            const $cognome = $('#f-cognome');
            const $ragione = $('#f-ragione');
            const $piva = $('#f-piva');
            const $email = $('#f-email');
            const $privacy = $('#f-privacy');

            const nome = $nome.val().trim();
            const cognome = $cognome.val().trim();
            const ragione = $ragione.val().trim();
            const piva = $piva.val().trim();
            const email = $email.val().trim();
            const privacy = $privacy.prop('checked');

            // Reset errori
            $('.form-row').removeClass('woocommerce-invalid');
            ventura.formPivaMessages.clear();

            let hasError = false;

            if (!nome) {
                ventura.formPivaMessages.show('error', "Il campo Nome è obbligatorio.");
                $nome.closest('.form-row').addClass('woocommerce-invalid');
                hasError = true;
            }

            if (!cognome) {
                ventura.formPivaMessages.show('error', "Il campo Cognome è obbligatorio.");
                $cognome.closest('.form-row').addClass('woocommerce-invalid');
                hasError = true;
            }

            if (!ragione) {
                ventura.formPivaMessages.show('error', "Il campo Ragione Sociale è obbligatorio.");
                $ragione.closest('.form-row').addClass('woocommerce-invalid');
                hasError = true;
            }

            if (!piva) {
                ventura.formPivaMessages.show('error', "Il campo Partita IVA è obbligatorio.");
                $piva.closest('.form-row').addClass('woocommerce-invalid');
                hasError = true;
            } else if (!ventura.formPivaValidation.validatePIVA(piva)) {
                ventura.formPivaMessages.show('error', "Partita IVA non valida (11 cifre).");
                $piva.closest('.form-row').addClass('woocommerce-invalid');
                hasError = true;
            }

            if (!email) {
                ventura.formPivaMessages.show('error', "Il campo Email è obbligatorio.");
                $email.closest('.form-row').addClass('woocommerce-invalid');
                hasError = true;
            } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
                ventura.formPivaMessages.show('error', "Inserisci un indirizzo email valido.");
                $email.closest('.form-row').addClass('woocommerce-invalid');
                hasError = true;
            }

            if (!privacy) {
                ventura.formPivaMessages.show('error', "Devi accettare la privacy per procedere.");
                $privacy.closest('.form-row').addClass('woocommerce-invalid');
                hasError = true;
            }

            if (hasError) {
                // Scroll al primo errore
                $('html, body').animate({
                    scrollTop: $('.woocommerce-invalid:first').offset().top - 100
                }, 500);
                return false;
            }

            // Se tutti i controlli sono passati, invio AJAX
            $.ajax(WP_PARAMS.ajax_url, {
                type: 'POST',
                data: {
                    nome: nome,
                    cognome: cognome,
                    ragione_sociale: ragione,
                    partita_iva: piva,
                    email: email,
                    privacy: privacy,
                    action: "zohoFormPivaSubscription",
                    nonce: WP_PARAMS.zoho_form_nonce 
                },
                success: function (response) {
                    if (response.success) {
                        ventura.formPivaMessages.show('success', response.data.message);
                        
                        // Redirect alla thank you page
                        if (response.data.redirect_url) {
                            window.location.href = response.data.redirect_url;
                        }
                    } else {
                        ventura.formPivaMessages.show('error', response.data.message);
                        $('#btn-submit').prop('disabled', false).text('Entra nel Mondo Ventura');
                    }
                },
                error: function(xhr, status, error) {
                    ventura.formPivaMessages.show('error', "Errore durante l'invio del form.");
                    $('#btn-submit').prop('disabled', false).text('Entra nel Mondo Ventura');
                }
            });
            
            return false;
        });
    };

    // Document ready
    $(document).on('venturaReady', function() {
        ventura.formPivaSubscription();
    });

})(jQuery);
